import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './app.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Partnerships from './components/Partnerships';
import Footer from './components/Footer';

function App() {
    const aboutRef = useRef(null);

    const handleAboutClick = () => {
        aboutRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const MainLayout = () => (
        <>
            <Hero />
            <hr className="section-divider" />
            <About ref={aboutRef} />
            <Services />
            <Contact />
        </>
    );

    return (
        <Router>
            <div className="App">
                <div className="content-hider"></div>
                <Navbar onAboutClick={handleAboutClick} />
                <div className="scroll-container">
                    <Routes>
                        <Route path="/" element={<MainLayout />} />
                        <Route path="/partnerships" element={<Partnerships />} />
                    </Routes>
                    <Footer />
                </div>
            </div>
        </Router>
    );
}

export default App;
